import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(360deg)
  }
`;

const animation = css`
  animation: ${spin} 2s linear infinite;
`;

export const Spinner = styled.div`
  border: 8px solid ${({ theme: { colours } }) => colours.crowberryBlue};
  border-top: 8px solid ${({ theme: { colours } }) => colours.gallery};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  inset: 0;
  margin: auto;
  z-index: ${({ theme }) => theme.zIndex.level_4};
  ${animation};
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  margin: ${({ theme }) => theme.spacing(20)} 0;
  justify-content: center;
`;
